import React from 'react';

import { StyledMark } from './styles';

/**
 * Renders `text` with every case-insensitive occurrence of `query` wrapped in a
 * highlight, so a user can see which part of a search result matched what they typed.
 */
const HighlightedText = ({ text, query }: { text: string; query?: string }): React.ReactElement => {
  const needle = query?.trim().toLowerCase();

  if (!needle) {
    return <>{text}</>;
  }

  const lower = text.toLowerCase();
  const segments: { value: string; match: boolean }[] = [];
  let cursor = 0;

  while (cursor < text.length) {
    const matchStart = lower.indexOf(needle, cursor);

    if (matchStart === -1) {
      segments.push({ value: text.slice(cursor), match: false });
      break;
    }

    if (matchStart > cursor) {
      segments.push({ value: text.slice(cursor, matchStart), match: false });
    }

    segments.push({ value: text.slice(matchStart, matchStart + needle.length), match: true });
    cursor = matchStart + needle.length;
  }

  return (
    <>
      {segments.map((segment, index) =>
        segment.match ? (
          <StyledMark key={index}>{segment.value}</StyledMark>
        ) : (
          <React.Fragment key={index}>{segment.value}</React.Fragment>
        )
      )}
    </>
  );
};

export default HighlightedText;
